





















































































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import TitleArea from '@/components/TitleArea.vue';
import { getTerapeutaById, Terapeuta, TerapeutaSteroids } from '@/plugins/utils/terapeutasUtils';
import { checkDoc, checkRecepcao, nl2br, pad, timeStringToTime } from '@/plugins/utils/utils';
import { DiaSemana, DiaSemanaObject, diasSemana, getMapasHelpers } from '@/plugins/utils/marcacaoUtils';
import { checkTratamentoAux, Tratamentos } from '@/plugins/utils/consultaUtils';

interface DiaSemanaObjectActive extends DiaSemanaObject{
  activo: boolean;
}

@Component({
  components: {
    TitleArea
  }
})
export default class TerapeutasMapa extends Vue {

  nl2brLocal(text: string): string{
    return nl2br(text, false);
  }

  flag_simple = true;
  item_simple_full: {
    id_terapeuta: number; 
    dia: string; 
    hora: string;
  } | null = null;
  toogleItemSF(id_terapeuta: number, dia: string, hora: string){
    if(this.checkItemSF(id_terapeuta, dia, hora)){
      this.item_simple_full = null;  
    }
    else{
      this.item_simple_full = {
        id_terapeuta:id_terapeuta,
        dia: dia,
        hora: hora
      }
    }
  }
  checkItemSF(id_terapeuta: number, dia: string, hora: string): boolean{
    if(
      this.item_simple_full && 
      this.item_simple_full.id_terapeuta == id_terapeuta && 
      this.item_simple_full.dia == dia && 
      this.item_simple_full.hora == hora
    ){
      return true;
    }
    else{
      return false;
    }
  }
  
  terapeutas: TerapeutaSteroids[] = [];
  diasSemanaT: DiaSemanaObjectActive[] = [];
  horas: string[] = [];

  primaryColor = this.$vuetify.theme.themes.light.primary;
  
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  marcacoesTerapeutas: any[] = []; 
  id_terapeuta: number | null = null;
  created() {
    diasSemana.forEach(element => {
      const el: DiaSemanaObjectActive = {
        value: element.value,
        index: element.index,
        abrev: element.abrev,
        text: element.text,
        activo: true
      }
      this.diasSemanaT.push(el);
    });
    if(this.$route.params.id_terapeuta){
      this.id_terapeuta = parseInt(this.$route.params.id_terapeuta);

      getMapasHelpers(
        null,
        (helpers) => {
          // console.log(helpers);
          helpers.terapeutas.forEach((terapeuta) => {
            if(terapeuta.id == this.id_terapeuta){
              this.terapeutas.push({
                activo: true,
                dados: new Terapeuta(terapeuta),
                horas: []
              });
            }
          });
          if(helpers.marcacoes){
            this.marcacoesTerapeutas = helpers.marcacoes;
          }
          
          if(this.terapeutas.length == 1){
            this.terapeutas.forEach(t => {
              t.horas = this.constructSlots2(t.dados);
            });

            this.horas = this.constructSlots();
          }
          else {
            this.idErrorHandler();
          }
          
          // console.info("terapeutas", this.terapeutas);

          this.$store.commit("setLoading", false);
        },
        () => {
          this.idErrorHandler();
        }
      );
    
    }
    else{
      this.idErrorHandler();
    }

  }

  get diasTable(): DiaSemanaObjectActive[]{
    const returnDays: DiaSemanaObjectActive[] = [];
    this.diasSemanaT.forEach(e => {
      if(e.activo){
        returnDays.push(e);
      }
    })
    return returnDays;
  }

  idErrorHandler(): void{
    this.$store.commit("setLoading", false);
    this.$store.commit("setError", {flag: true, text: "Terapeuta inválido", status: "error"});
    this.$router.push("/terapeutas");
  }

  getTime(stringTime: string): number{
    return timeStringToTime(stringTime);
  }

  checkFirstHour(tempoSlot: number): number{
    let id = 1;
    let hora_inicial = new Date();
    hora_inicial.setSeconds(59);
    hora_inicial.setMinutes(59);
    hora_inicial.setHours(23);
    for (let index = 0; index < this.terapeutas.length; index++) {
      const terapeuta = this.terapeutas[index];
      const horaEntrada = terapeuta.dados.horaEntrada;
      if(horaEntrada != null && tempoSlot === terapeuta.dados.tempoSlot){
        if(horaEntrada.getTime() < hora_inicial.getTime() ){
          hora_inicial = horaEntrada;
          id = terapeuta.dados.id; 
        }
      }
    }
    return id;
  } 

  checkLastHour(tempoSlot: number): number{
    let id = 1;
    let hora_inicial = new Date();
    hora_inicial.setSeconds(0);
    hora_inicial.setMinutes(0);
    hora_inicial.setHours(0);
    for (let index = 0; index < this.terapeutas.length; index++) {
      const terapeuta = this.terapeutas[index];
      const horaSaida = terapeuta.dados.horaSaida;
      if(horaSaida != null && tempoSlot == terapeuta.dados.tempoSlot){
        if(horaSaida.getTime() > hora_inicial.getTime() ){
          hora_inicial = horaSaida;
          id = terapeuta.dados.id; 
        }
      }
    }
    return id;
  }

  checkSmallInterval(): number{
    let id = 1;
    let small = 10000;
    for (let index = 0; index < this.terapeutas.length; index++) {
      const terapeuta = this.terapeutas[index];
      if(terapeuta.dados.tempoSlot < small){
        small = terapeuta.dados.tempoSlot;
        id = terapeuta.dados.id;
      }
    }
    return id;
  }

  constructSlots(): string[]{
    const horas: string[] = [];
    // CHECK FIRST HOUR
    const idMaisCedo = this.checkFirstHour(30);
    // console.log(idMaisCedo);

    // CHECK Last HOUR
    const idMaisTarde = this.checkLastHour(30);
    // console.log(idMaisTarde);

    // CHECK MINOR INTERVAL
    const idSmallInterval = this.checkSmallInterval();
    // console.log(idSmallInterval);

    const tCedo = getTerapeutaById(idMaisCedo, this.terapeutasSimples);
    const tTarde = getTerapeutaById(idMaisTarde, this.terapeutasSimples);
    const tInterval = getTerapeutaById(idSmallInterval, this.terapeutasSimples);
    if(tCedo != null && tTarde != null && tInterval != null){
      const timeStart = tCedo.horaEntrada as Date;
      const timeEnd = tTarde.horaSaida as Date; 
      const interval = tInterval.tempoSlot; 

      let i = timeStart;
      while (i<= timeEnd) {
        horas.push( pad(i.getHours(),2) + ":" + pad(i.getMinutes(), 2));
        i = new Date(i.getTime() + interval*60*1000 );
      }
    }

    return horas;
  }

  constructSlots2(terapeuta: Terapeuta): string[]{
    const horas: string[] = [];

    // console.log("terapeuta", terapeuta.nome);
    // CHECK FIRST HOUR
    const idMaisCedo = this.checkFirstHour(terapeuta.tempoSlot);
    // console.log("id mais cedo",idMaisCedo);

    // CHECK Last HOUR
    const idMaisTarde = this.checkLastHour(terapeuta.tempoSlot);
    // console.log("id mais tarde", idMaisTarde);

    // CHECK MINOR INTERVAL
    // const idSmallInterval = this.checkSmallInterval();
    // console.log(idSmallInterval);

    const tCedo = getTerapeutaById(idMaisCedo, this.terapeutasSimples);
    const tTarde = getTerapeutaById(idMaisTarde, this.terapeutasSimples);
    // console.log(tCedo);
    // console.log(tTarde);
    // const tInterval = getTerapeutaById(idSmallInterval, this.terapeutasSimples);
    if(tCedo != null && tTarde != null){
    
      const timeStart = tCedo.horaEntrada as Date;
      const timeEnd = tTarde.horaSaida as Date; 
      const timeAlmoco = terapeuta.horaAlmoco as Date; 
      const timeTarde = terapeuta.horaTarde as Date; 
      const interval = terapeuta.tempoSlot; 

      let i = timeStart;
      while (i< timeAlmoco) {
        horas.push( pad(i.getHours(),2) + ":" + pad(i.getMinutes(), 2));
        i = new Date(i.getTime() + interval*60*1000 );
      }
      
      i = timeAlmoco;
      while (i< timeTarde) {
        horas.push( pad(i.getHours(),2) + ":" + pad(i.getMinutes(), 2));
        i = new Date(i.getTime() + interval*60*1000 );
      }

      i = timeTarde;
      while (i<= timeEnd) {
        horas.push( pad(i.getHours(),2) + ":" + pad(i.getMinutes(), 2));
        i = new Date(i.getTime() + interval*60*1000 );
      }

    }

    return horas;
  }


  get terapeutasSimples(): Terapeuta[]{
    const newTerapeutas: Terapeuta[] = [];

    this.terapeutas.forEach(t => {
      newTerapeutas.push(t.dados);
    })

    return newTerapeutas;
  }
  get terapeutasMapas(): TerapeutaSteroids[]{
    const newTerapeutas: TerapeutaSteroids[] = [];

    this.terapeutas.forEach(t => {
      if(t.activo)
        newTerapeutas.push(t);
    })

    return newTerapeutas;
  }

  checkHoraOut(terapeuta: TerapeutaSteroids, hora: string): boolean{
    if(
      terapeuta.dados.horaEntrada.getTime() > this.getTime(hora) || 
      terapeuta.dados.horaSaida.getTime() < this.getTime(hora) || 
      (terapeuta.dados.horaAlmoco.getTime() <= this.getTime(hora) 
        && terapeuta.dados.horaTarde.getTime() > this.getTime(hora
        )
      )
    ) {
      return true;
    } else {
      return false;
    }
  }
  checkDiaTrabalho(terapeuta: TerapeutaSteroids, dia_semana: DiaSemana): boolean{
    if(terapeuta.dados.horarios.length == 0){
      return true;
    } 
    else{
      let flag_found = 0;
      for (let index = 0; index < terapeuta.dados.horarios.length; index++) {
        const horario = terapeuta.dados.horarios[index];
        if(horario.dia_semana == dia_semana){
          index = terapeuta.dados.horarios.length;
          flag_found = 1;
        }
      }
      if(flag_found == 1) return true;
      else return false;
    }
  }


  checkHoraTransporte(terapeuta: TerapeutaSteroids, hora: string): boolean{
    if(
      terapeuta.dados.horaTransporte.getTime() <= this.getTime(hora) && 
      terapeuta.dados.horaFimTransporte.getTime() > this.getTime(hora)
    ) {
      return true;
    } else {
      return false;
    }
  }
  checkSlotEspecial(id_terapeuta: number, dia: string, hora: string): boolean{
    let retturn_flag = false;
    if(
      this.marcacoesTerapeutas[id_terapeuta] && 
      this.marcacoesTerapeutas[id_terapeuta][dia] &&
      this.marcacoesTerapeutas[id_terapeuta][dia][hora]
    ){
      const array = this.marcacoesTerapeutas[id_terapeuta][dia][hora];
      for (let index = 0; index < array.length; index++) {
        const item = array[index];
        if(item.flag_especial == 1){
          retturn_flag = true;
          index = array.length;
        }
      }
    }
    return retturn_flag;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getSlotTerapeuta(id_terapeuta: number, dia: string, hora: string): any[]{
    // let total: number | null = null;
    if(
      this.marcacoesTerapeutas[id_terapeuta] && 
      this.marcacoesTerapeutas[id_terapeuta][dia] &&
      this.marcacoesTerapeutas[id_terapeuta][dia][hora]
    ){ 
      // console.log(this.marcacoesTerapeutas[id_terapeuta][dia][hora+":00"]);
      return this.marcacoesTerapeutas[id_terapeuta][dia][hora];
    }
    else {
      return [];
    }
  }

  getTotalSlotTerapeuta(id_terapeuta: number, dia: string, hora: string): number | null{
    let total: number | null = null;
    if(
      this.marcacoesTerapeutas[id_terapeuta] && 
      this.marcacoesTerapeutas[id_terapeuta][dia] &&
      this.marcacoesTerapeutas[id_terapeuta][dia][hora]
    ){

      total = this.marcacoesTerapeutas[id_terapeuta][dia][hora].length;
    }
    if(total == 0) total = null;
    return total;
  }


  get checkRecepcao(): boolean{
    if(this.$store.getters.userData && this.$store.getters.userData.nivel)
      return checkRecepcao(this.$store.getters.userData.nivel);
    else
      return false;
  }
  get checkDoc(): boolean{
    if(this.$store.getters.userData && this.$store.getters.userData.nivel)
      return checkDoc(this.$store.getters.userData.nivel);
    else
      return false;
  }

  tratamentosDividedDinamico(tratamento: string): Tratamentos | null{
    if(tratamento){
      return checkTratamentoAux(tratamento, this.$store.getters.separatorAux);
    } else {
      return null;
    }
  }
}
